import { toPaginate, getFiltersGlobalFilters } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';
import { CoreEnums } from '@/utils/domain/constants';

const api = bindServices('userGroupApproverPosition');
const { BulkActionType } = CoreEnums;

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'userGroupApproverPosition',
  state: {
    newApproversGroup: false,
    selectedItem: null,
    list: [],
    pagination: meta,
    select: 'id,approvalLevel',
    notSelectSearch: 'approvalLevel',
    expand: {
      position: { select: 'id,name' },
      userGroup: { select: 'id,name' },
    },
    paramsView: {
      select: 'id,approvalLevel,updated,created',
      expand: {
        position: { select: 'id,name' },
        userGroup: { select: 'id,name' },
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select: 'id,approvalLevel',
      expand: {
        position: { select: 'id,name' },
        userGroup: { select: 'id,name' },
      },
    },
    view: false,
    orderBy: '',
    id: null,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'globalUserGroupApproverByPosition/paged',
          params: payload,
        });
        yield put({
          type: 'queryApproversGroups',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *addNewApproversGroup({ payload }, { put }) {
      yield put({
        type: 'addApproversGroups',
        payload,
      });
    },
    *saveNewApproversGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'globalUserGroupApproverByPosition',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApproversGroup',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *editItemApproversGroup({ payload }, { call, put }) {
      try {
        yield put({
          type: 'editApproversGroups',
          payload: {
            ...payload,
            state: true,
            item: null,
            view: false,
          },
        });
        const table = yield call(api.getById, {
          route: 'globalUserGroupApproverByPosition',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editApproversGroups',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveEditApproversGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'globalUserGroupApproverByPosition',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveApproversGroup',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          payload: {
            state: false,
            id: null,
          },
        });
        if (view) {
          yield put({
            type: 'addApproversGroups',
            payload: {
              state: false,
              item: null,
              view: false,
              id: null,
            },
          });
        }
        const response = yield call(api.apiRoute, {
          route: `globalUserGroupApproverByPosition/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          payload: {
            state: false,
            id: null,
          },
        });
        if (error && error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *bulkDeleteUserGroupApproverPosition({ payload }, { call, put, select }) {
      try {
        const { ids } = payload;
        if (!ids || ids.length === 0) return;

        yield call(api.bulkAction, {
          route: 'globalUserGroupApproverByPosition',
          bulkActionType: BulkActionType.Delete,
          ids,
        });

        const currentState = yield select((state) => state.userGroupApproverPosition);
        const globalState = yield select((state) => state.global);

        const { pageSize, isActive, globalFilters, searchCriteria } = globalState;
        const filters = getFiltersGlobalFilters(globalFilters, 'userGroupApproverPosition');
        const combinedFilter = [isActive, filters].filter(Boolean).join(' and ') || null;

        const params = {
          ...currentState.pagination,
          page: 1,
          ...(pageSize && { limit: pageSize }),
          ...(searchCriteria && { search: searchCriteria }),
          ...(currentState.notSelectSearch && { notSelectSearch: currentState.notSelectSearch }),
          ...(combinedFilter && { filter: combinedFilter }),
          ...(currentState.orderBy && { orderBy: currentState.orderBy }),
          ...(currentState.expand && { expand: currentState.expand }),
          ...(currentState.select && { select: currentState.select }),
        };

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
  },
  reducers: {
    queryApproversGroups(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addApproversGroups(state, { payload }) {
      return {
        ...state,
        newApproversGroup: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editApproversGroups(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    saveApproversGroup(state, { payload }) {
      return {
        ...state,
        saveApproversGroup: payload,
        newApproversGroup: false,
        selectedItem: null,
        view: false,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        newApproversGroup: false,
        selectedItem: null,
        list: [],
        view: false,
        orderBy: '',
      };
    },
  },
};

export default Model;
